import React from 'react';

import { Modal, Title } from '@mantine/core';
import KiloAlert from 'components/KiloAlert';
import type { PackageUtilizationExpectationListItem } from 'types';

import { ModalType, useModal } from './Context/ModalContext';
import {
  DeleteExpectationForm,
  EditExpectationForm,
  ListExpectationsForm,
  RegisterExpectationForm,
} from './Forms';

const renderContent = (
  type: ModalType,
  packageExpectation?: PackageUtilizationExpectationListItem | null,
): JSX.Element => {
  switch (type) {
    case 'register':
      return <RegisterExpectationForm />;

    case 'list':
      return <ListExpectationsForm />;

    case 'edit':
      if (!packageExpectation) {
        return (
          <KiloAlert variantStyle='error' title='Error'>
            No package selected to edit
          </KiloAlert>
        );
      }
      return <EditExpectationForm packageExpectation={packageExpectation} />;

    case 'delete':
      if (!packageExpectation) {
        return (
          <KiloAlert variantStyle='error' title='Error'>
            No package selected to delete
          </KiloAlert>
        );
      }
      return <DeleteExpectationForm packageExpectation={packageExpectation} />;
    default:
      return <></>;
  }
};

const ManagePackagesModal = (): JSX.Element => {
  const { modal, closeModal } = useModal();
  const { type, opened, packageExpectation } = modal;

  return (
    <Modal
      opened={opened}
      onClose={closeModal}
      title={<Title order={4}>Manage Packages</Title>}
      size='xl'
      styles={{
        content: {
          minHeight: '25rem',
          maxHeight: '40rem',
        },
      }}
    >
      {renderContent(type, packageExpectation)}
    </Modal>
  );
};

export default ManagePackagesModal;
